<template lang="pug">
div.confirm-layout
  div.alert.alert-success
    span(v-if="returnToEmptyDeviceId") 退回不同批號藥物，將退至空藥盒
    span(v-else-if="currentDrugInDevice !== null && currentSystem.settings.return_to_original_cmpn")
      span 藥盒數量/上限: {{ currentDrugInDevice.stock }} / {{ currentDrugInDevice.max_stock }} 
      span.float-right 藥物總數量/上限: {{$store.state.drug.selectedDrugTotalAmount}} /{{$store.state.drug.selectedDrugTotalMax}} 
    span(v-else) 未設定退回原藥盒
  ConfirmReason(
    v-if="currentProgress === 'selectReason'"
    v-on:setReason="getReason"
  )
  TextInput(
    v-show="currentProgress === 'medIdInput'"
    :inputLabel="'輸入病歷號'"
    :defaultContent="medRecordId"
    v-on:setText="getMedId"
  )
  TextInput(
    v-show="currentProgress === 'setPatchNo'"
    :inputLabel="'確認批號'"
    :defaultContent="patchNo"
    v-on:setText="getPatchNo"
  )
  ConfirmExpiredDate(
    v-if="currentProgress === 'setExpiredDate'"
    :defaultExpirationDate="defaultExpiredDate"
    :editable="expiredDateEditable"
    v-on:setExpirationDate="getExpiredDate"
  )
  ConfirmStorage(
    v-if="currentProgress === 'setStorage'"
    :inputLabel="'設定退藥數量'"
    :defaultAmount="defaultReturnAmount"
    v-on:setNum="getStorage"
  )
  RxCheckBarcode(
    v-if="currentProgress === 'rxCheck'"
    v-on:confirmRx="confirmRx"
  )
  ActionWrap(
    v-if="currentProgress === 'action'"
    v-on:setActionData="getActionData"
    v-on:finishAction="finishAction"
    :amountPayload="amountPayload"
    :actionProgress="actionProgress"
    :returnToEmptyDeviceId="returnToEmptyDeviceId"
    :actionRecorded="actionRecorded"
  )
  ConfirmModal(
    v-if="showPatchConfirmModal"
    :message="'輸入批號與目前藥盒不同，是否繼續退藥？'"
    v-on:response="confirmPatchChoice"
  )
</template>

<script>
import moment from 'moment';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import ConfirmReason from '../flowComp/Reason';
import ConfirmStorage from '../flowComp/NumberSet';
import ConfirmExpiredDate from '../flowComp/DateSelection';
import TextInput from '../flowComp/TextInput';
import ActionWrap from './ActionWrap';
import ConfirmModal from '../common/Confirm';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';

export default {
  name: 'confirmFlow',
  extends: ConfirmFlowBase,
  components: {
    ConfirmReason,
    ConfirmStorage,
    ConfirmExpiredDate,
    ActionWrap,
    TextInput,
    ConfirmModal,
    RxCheckBarcode,
  },
  props: ['barcodeData', 'startType'],
  data() {
    return {
      reasonId: '',
      storage: 0,
      expiredDate: '',
      patchNo: '',
      device: '',
      returnNum: '',
      medRecordId: '',
      defaultReturnAmount: 0,
      amountPayload: {
        amount: 0,
        packCount: 0,
      },
      showPatchConfirmModal: false,
      returnToEmptyDeviceId: undefined,
      recoredEventIDs: [],
      actionRecorded: false,
      reviewer: undefined,
    };
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    if (this.startType === 'event') {
      this.medRecordId = this.currentEvent.med_record_no;
      this.patchNo = this.currentEvent.batch_no;
      this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
    }
    if (this.startType === 'drugStorage') {
      this.patchNo = this.currentDrugInDevice.patch_number;
    }
  },
  methods: {
    confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    getMedId(data) {
      this.medRecordId = data;
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.nextProgress();
      }
    },
    getPatchNo(data) {
      this.patchNo = data;
      if (this.patchNo === this.currentDrugInDevice.patch_number) {
        this.nextProgress();
      } else {
        console.log('not same patch number');
        if (this.currentDrugInDevice.medication.restrained_class > 0 && data === '') {
          this.$store.commit('SET_MESSAGE', { type: 'warn', context: '管制藥物批號不可為空' });
        } else {
          this.showPatchConfirmModal = true;
        }
      }
    },
    async confirmPatchChoice(response) {
      if (response) {
        await this.$store.dispatch('getSystemInfo'); // make sure all system are latest.
        this.returnToEmptyDeviceId = this.findLargerEmptyDevice();
        console.log(this.returnToEmptyDeviceId);
        if (this.returnToEmptyDeviceId !== null) {
          this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', this.returnToEmptyDeviceId);
          this.nextProgress();
        }
        // find empty and larger device to input
      }
      this.showPatchConfirmModal = false;
    },
    findLargerEmptyDevice() {
      let targetDeviceIndex = '';
      const devicesList = Object.values(this.allDevices);
      if (this.currentDrugInDevice.device.pos_col === 0) { // F type;
        targetDeviceIndex = devicesList.findIndex((o) => { return o.adc_type === 'F' && o.specific_type === null; });
      } else { // A Type
        targetDeviceIndex = devicesList.findIndex((o) => { return o.adc_type === 'A' && o.drugstorage_set.length === 0 && o.specific_type === null && o.width >= this.currentDrugInDevice.device.width; });
        console.log(targetDeviceIndex);
        if (targetDeviceIndex === -1) {
          targetDeviceIndex = devicesList.findIndex((o) => { return o.adc_type === 'F' && o.specific_type === null; });
        }
      }
      console.log(targetDeviceIndex);
      if (targetDeviceIndex === -1) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '找不到合適的空藥盒，請聯絡管理人員處理。',
        });
        return null;
      }
      return devicesList[targetDeviceIndex].id;
    },
    getReason(reasonId) {
      console.log(reasonId);
      this.reasonId = reasonId;
      if (this.barcodeData.amount !== undefined) {
        // go directly to action.
        this.storage = this.barcodeData.amount;
        this.expiredDate = this.currentEvent.drug_storage.expired_date;
      }
      this.nextProgress();
    },
    getStorage(num) {
      // deprecated.
      this.amountPayload.amount = num;
      this.storage = num;
      if (num > Math.abs(this.currentEvent.number1) && this.returnToEmptyDeviceId === undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '退回數量不可大於該次取藥數量',
        });
      } else {
        this.nextProgress();
      }
    },
    getMedRecordNo(val) {
      this.med_record_no = val;
    },
    getExpiredDate(data) {
      console.log(data);
      this.expiredDate = data;
      this.nextProgress();
    },
    getActionData(item) {
      console.log(item);
      this.actionRecorded = false;
      // handle drugStorage data
      if ('drugStorage' in item) {
        const data = {
          id: item.drugStorage.id,
          device: item.drugStorage.device.id,
          stock: item.drugStorage.stock += item.num,
          medication: item.drugStorage.medication.id,
          reason: this.reasonId,
          med_record_no: this.medRecordId,
          number1: item.num,
          pack_count: item.drugStorage.pack_count += item.packCount,
          type: 'RETURN',
          review_employee: this.reviewer,
        };
        this.instance.put(`/api/drug-storage/${item.drugStorage.id}/`, data)
        .then((res) => {
          this.recoredEventIDs.push(res.data);
          this.actionRecorded = true;
        });
      } else {
        // handle device data, speific for external cmpn, return cmpn or empty devices.
        const data = {
          device: item.device,
          stock: item.num,
          max_stock: item.num,
          expired_date: this.expiredDate !== '' ? this.expiredDate : moment().format('YYYY-MM-DD'),
          patch_number: this.patchNo,
          medication: this.currentDrugInDevice.medication.id,
          reason: this.reasonId,
          med_record_no: this.medRecordId,
          number1: item.num,
          pack_count: 0, // since drug on return in pc. not box.
          type: 'RETURN',
          review_employee: this.reviewer,
        };

        // dirty hack, not quite sure why sometimes the data is not an object but key.
        // if (this.currentDrugInDevice.medication.id === undefined) {
        //   drugStorage.medication = this.currentDrugInDevice.medication;
        // }

        // if this is returned to external cmpn or return cmpn, then it should create, not put.
        this.instance.post('/api/drug-storage/', data)
        .then((res) => {
          this.recoredEventIDs.push(res.data);
          this.actionRecorded = true;
        });
      }
    },
    async finishAction() {
      if (this.startType === 'event') {
        const event = {
          id: this.currentEvent.id,
          checked: true,
          related_events: this.recoredEventIDs,
        };
        await this.instance.patch(`/api/event/${event.id}/`, event);
      }
      this.$emit('confirmationFinish');
      this.resetProgress();
    },
  },
  computed: {
    externalCmpn() {
      return this.$store.state.externalCmpn;
    },
    selectedDrugTotalMax() {
      return this.$store.state.drug.selectedDrugTotalMax;
    },
    defaultExpiredDate() {
      if (this.returnToEmptyDeviceId) {
        return null;
      }
      return this.currentDrugInDevice.expired_date;
    },
    expiredDateEditable() {
      if (this.returnToEmptyDeviceId) {
        return true;
      }
      return false;
    },
    allDevices() {
      return this.$store.state.device.allDevices;
    },
  },
  watch: {
    currentEvent(val) {
      if (this.startType === 'event') {
        this.medRecordId = this.currentEvent.med_record_no;
        this.patchNo = this.currentEvent.batch_no;
        this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
      }
    },
    currentDrugInDevice(val) {
      if (this.startType === 'drugStorage') {
        this.patchNo = this.currentDrugInDevice.patch_number;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?740bb8c3